import tw, { styled } from 'twin.macro';
import Input from '../components/Input/Input';

export const StyledForm = styled.form`
  ${tw`flex flex-col gap-2`}
`;

export const StyledHiddenInput = styled(Input)`
  ${tw`hidden`}
`;
